import { keyframes, styled } from "@mui/material/styles";

interface SpinnerProps {
  width?: number;
  height?: number;
  color?: string;
  radius?: number;
  strokeWidth?: number;
  visible?: boolean;
}

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerContainer = styled("div")<{
  width: string;
  height: string;
}>(({ width, height }) => ({
  display: "inline-block",
  width,
  height,
}));

const SpinnerCircle = styled("div")<{
  color: string;
  strokeWidth: number;
}>(({ color, strokeWidth }) => ({
  width: "100%",
  height: "100%",
  border: `${strokeWidth}px solid transparent`,
  borderTop: `${strokeWidth}px solid ${color}`,
  borderLeft: `${strokeWidth}px solid ${color}`,
  borderRadius: "50%",
  animation: `${spin} 1s linear infinite`,
}));

export const Spinner = ({
  width = "40px",
  height = "40px",
  color = "#3366CC",
  strokeWidth = 4,
  visible = true,
}: SpinnerProps) => {
  if (!visible) return null;

  const sizeWidth = typeof width === "number" ? `${width}px` : width;
  const sizeHeight = typeof height === "number" ? `${height}px` : height;

  return (
    <SpinnerContainer width={sizeWidth} height={sizeHeight}>
      <SpinnerCircle color={color} strokeWidth={strokeWidth} />
    </SpinnerContainer>
  );
};
